module.exports = __webpack_public_path__ + "img/advance3.ac40c91e.png";